// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"e26a3156","977":"973cd497"}[chunkId] + ".chunk.js";
};